<!--
 * @Author:
 * @Description:步骤1-验证你的业务
 * @Date: 2024-09-09 14:11:44
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/register/networkApplication/components/step-bankAccount.vue
-->
<template>
  <div class="step_bankAccount">
    <div>
      <p class="descript1"> {{ $t('message.register.validateBusiness.bankAccount.descript1') }}</p>
      <p class="descript2">{{ $t('message.register.validateBusiness.bankAccount.descript2') }}</p>
    </div>
    <validation-component ref="validationForm" :validation-condition="validationCondition">
      <div slot="proofOfBankAccount">
        <template>
          <RhcnUpload :title="$t('message.register.bankAccount_desc.Account Opening Proof')"
            :fileList="form.uploadExtraProofs.fileList.proofOfBankAccount"
            :on-change="onMaterialItemChange('form', 'uploadExtraProofs', 'proofOfBankAccount')"
            :on-remove="onMaterialItemRemove('form', 'uploadExtraProofs', 'proofOfBankAccount')" :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>
      <div slot="uploadBankStatement">
        <template>
          <RhcnUpload :title="$t('message.register.bankAccount_desc.Upload bank statement')"
            :fileList="form.uploadExtraProofs.fileList.uploadBankStatement"
            :on-change="onMaterialItemChange('form', 'uploadExtraProofs', 'uploadBankStatement')"
            :on-remove="onMaterialItemRemove('form', 'uploadExtraProofs', 'uploadBankStatement')"
            :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>
      <div slot="extraDocument1">
        <template>
          <RhcnUpload :title="$t('message.register.businessDetails.extra_document_1')"
            :fileList="form.uploadExtraProofs.fileList.extraDocument1"
            :on-change="onMaterialItemChange('form', 'uploadExtraProofs', 'extraDocument1')"
            :on-remove="onMaterialItemRemove('form', 'uploadExtraProofs', 'extraDocument1')" :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>
      <div slot="extraDocument2">
        <template>
          <RhcnUpload :title="$t('message.register.businessDetails.extra_document_2')"
            :fileList="form.uploadExtraProofs.fileList.extraDocument2"
            :on-change="onMaterialItemChange('form', 'uploadExtraProofs', 'extraDocument2')"
            :on-remove="onMaterialItemRemove('form', 'uploadExtraProofs', 'extraDocument2')" :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>
      <div slot="extraDocument3">
        <template>
          <RhcnUpload :title="$t('message.register.businessDetails.extra_document_3')"
            :fileList="form.uploadExtraProofs.fileList.extraDocument3"
            :on-change="onMaterialItemChange('form', 'uploadExtraProofs', 'extraDocument3')"
            :on-remove="onMaterialItemRemove('form', 'uploadExtraProofs', 'extraDocument3')" :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>
      <div slot="extraDocument4">
        <template>
          <RhcnUpload :title="$t('message.register.businessDetails.extra_document_4')"
            :fileList="form.uploadExtraProofs.fileList.extraDocument4"
            :on-change="onMaterialItemChange('form', 'uploadExtraProofs', 'extraDocument4')"
            :on-remove="onMaterialItemRemove('form', 'uploadExtraProofs', 'extraDocument4')">
          </RhcnUpload>
        </template>
      </div>
      <div slot="extraDocument5">
        <template>
          <RhcnUpload :title="$t('message.register.businessDetails.extra_document_5')"
            :fileList="form.uploadExtraProofs.fileList.extraDocument5"
            :on-change="onMaterialItemChange('form', 'uploadExtraProofs', 'extraDocument5')"
            :on-remove="onMaterialItemRemove('form', 'uploadExtraProofs', 'extraDocument5')" :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>

    </validation-component>
    <div class="button-box">
      <el-button type="primary" @click="confirm" size="mini" :disabled="isDisabled">{{
        $t('message.exchange.continue') }}</el-button>
    </div>

  </div>
</template>

<script>

import { getDictionary } from '@/api/common/index';
import { REQUIRED } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import { businessLocation } from '@/utils/options/networkApplication';
import { transformDictionaryToOptions } from '@/utils/tools/constant';
import RhcnUpload from '@/views/account/information/supplement/upload/index.vue';
import { queryBankInfoBySwiftAndCountry } from '@/views/transfer/api/contact';

import mixins from '../../mixins';
export default {
  name: 'StepBankAccount',
  components: {
    ValidationComponent,
    RhcnUpload,
  },
  mixins: [mixins],
  data() {
    return {
      form: {
        uploadExtraProofs: {
          extraDocument1: '',
          extraDocument2: '',
          extraDocument3: '',
          extraDocument4: '',
          extraDocument5: '',
          uploadBankStatement: '',
          proofOfBankAccount: '',
          fileList: {
            extraDocument1: [],
            extraDocument2: [],
            extraDocument3: [],
            extraDocument4: [],
            extraDocument5: [],
            uploadBankStatement: [],
            proofOfBankAccount: [],
          },
        },
      },
      validationCondition: [
        {
          key: 'accountHolderName',
          name: 'message.register.bankAccount_desc.bank_name',
          type: 'input',
          defValue: '',
          isDisabled: true,
          placeholder: 'message.register.bankAccount_desc.placeholder.bank_name',
          options: businessLocation,
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'depositBank',
          name: 'message.register.bankAccount_desc.bank_address',
          type: 'select',
          defValue: '',
          rule: [REQUIRED],
          isShowStar: true,
          placeholder: 'message.register.bankAccount_desc.placeholder.bank_address',
          remote: true,
          noDataText: 'message.contact.atLeast3SwiftCodeTips',
          filterMethod: async (value) => {
            // TODO:新增参数
            // if (!this.formData.bankCountry) {
            //   return;
            // }
            const validationForm = this.$refs.validationForm;
            validationForm.setItemLoading('depositBank', true);
            let swiftCodeList = [];
            if (value && value.length > 2) {
              validationForm.setItemNoDataText('depositBank', 'message.common.noDataText');
              // TODO:新增参数;
              swiftCodeList = await queryBankInfoBySwiftAndCountry({ country: this.$attrs.formData.businessType.businessLocation === 'Hong Kong SAR China' ? 'HK' : 'GB', swiftCode: value });
            } else {
              validationForm.setItemNoDataText('depositBank', 'message.contact.atLeast3SwiftCodeTips');
              swiftCodeList = [];
            }
            validationForm.setItemLoading('depositBank', false);
            validationForm.setValidationSelectOptions('depositBank', swiftCodeList);
          },
          changeValue: () => {
            // this.checkFieldHasChanged();
          },
        },
        {
          key: 'bankAddress',
          name: 'message.register.bankAccount_desc.bank_account_location',
          type: 'input',
          defValue: '',
          placeholder: 'message.register.bankAccount_desc.placeholder.bank_account_location',
          isInternationalization: true,
          multiple: true,
          options: [],
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'currency',
          name: 'message.register.bankAccount_desc.Currency',
          type: 'select',
          defValue: '',
          placeholder: 'message.register.bankAccount_desc.placeholder.Currency',
          isInternationalization: true,
          multiple: true,
          options: [],
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'accountNumber',
          name: 'message.register.bankAccount_desc.bank_account_number_HK',
          type: 'input',
          defValue: '',
          placeholder: 'message.register.bankAccount_desc.placeholder.bank_account_number_HK',
          options: businessLocation,
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'confirmAccountNumber',
          name: 'message.register.bankAccount_desc.Confirm account number',
          type: 'input',
          defValue: '',
          placeholder: 'message.register.bankAccount_desc.placeholder.bank_account_number_HK',
          options: businessLocation,
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'proofOfBankAccount',
          name: 'message.register.bankAccount_desc.Account Opening Proof',
          type: 'slot',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'uploadBankStatement',
          name: 'message.register.bankAccount_desc.Upload bank statement',
          type: 'slot',
          options: businessLocation,
          isInternationalization: true,
          isShowStar: true,
          rule: [],
        },
        {
          key: 'uploadExtraProofs',
          name: 'message.register.bankAccount_desc.Upload extra proofs',
          type: 'slot',
          description: 'message.register.bankAccount_desc.placeholder.upload_extra_proofs',
          isInternationalization: true,
          isShowStar: true,
        },
        {
          key: 'extraDocument1',
          type: 'slot',
          isInternationalization: true,
          isShowStar: true,
        },
        {
          key: 'extraDocument2',
          type: 'slot',
          isInternationalization: true,
          isShowStar: true,
        },
        {
          key: 'extraDocument3',
          type: 'slot',
          isInternationalization: true,
          isShowStar: true,
        },
        {
          key: 'extraDocument4',
          type: 'slot',
          isInternationalization: true,
          isShowStar: true,
        },
        {
          key: 'extraDocument5',
          type: 'slot',
          isInternationalization: true,
          isShowStar: true,
        },
      ],
    };
  },

  created() {
    if (this.$attrs.formData.businessType.businessLocation === 'Hong Kong SAR China') {
      const accountNumberCondition = this.validationCondition.find(item => item.key === 'accountNumber');
      const confirmAccountNumberCondition = this.validationCondition.find(item => item.key === 'confirmAccountNumber');
      accountNumberCondition.name = 'message.register.bankAccount_desc.bank_account_number_HK';
      accountNumberCondition.placeholder = '000123-456';
      confirmAccountNumberCondition.placeholder = '000123-456';
    } else if (this.$attrs.formData.businessType.businessLocation === 'United Kingdom') {
      const accountNumberCondition = this.validationCondition.find(item => item.key === 'accountNumber');
      const confirmAccountNumberCondition = this.validationCondition.find(item => item.key === 'confirmAccountNumber');
      accountNumberCondition.name = 'message.register.bankAccount_desc.bank_account_number_UK';
      accountNumberCondition.placeholder = 'GB61CLRB12345678909876';
      confirmAccountNumberCondition.placeholder = 'GB61CLRB12345678909876';
    }

    if (this.$attrs.formData.businessDetails.legalBusinessName) {
      const accountNumberCondition = this.validationCondition.find(item => item.key === 'accountHolderName');
      accountNumberCondition.defValue = this.$attrs.formData.businessDetails.legalBusinessName;
    }

    getDictionary(['CURRENCY']).then((res) => {
      let CrurrencyList;
      switch (this.$attrs.formData.businessType.businessLocation) {
        case 'Hong Kong SAR China':
          CrurrencyList = transformDictionaryToOptions(res.CURRENCY).filter(item => ['HKD', 'USD'].includes(item.value));
          break;
        case 'United Kingdom':
          CrurrencyList = transformDictionaryToOptions(res.CURRENCY).filter(item => ['GBP', 'USD'].includes(item.value));
          break;
      }
      this.validationCondition.find(item => item.key === 'currency').options = CrurrencyList;
      // 要做下过滤，就算是使用字典也无法规避掉新怎币种要动代码的逻辑
    }).catch(() => ({}));
  },
  methods: {
    confirm() {
      this.$refs.validationForm.toFormValid(params => {
        const { accountHolderName, depositBank, currency, accountNumber, confirmAccountNumber, bankAddress } = params;
        // currency 如果是数组，转化为字符串
        const _currency = Array.isArray(currency) ? currency.join(',') : currency;
        const { uploadBankStatement, extraDocument1, extraDocument2, extraDocument3, extraDocument4, extraDocument5, proofOfBankAccount } = this.form.uploadExtraProofs;
        const bankAccount = {
          accountHolderName,
          depositBank,
          currency: _currency,
          accountNumber,
          confirmAccountNumber,
          uploadBankStatement,
          bankAddress,
          proofOfBankAccount,
          uploadExtraProofs: {
            extraDocument1,
            extraDocument2,
            extraDocument3,
            extraDocument4,
            extraDocument5,
          },
        };
        this.$emit('updateFormData', { bankAccount, currentStep: 'bankAccount', nextStep: 'status' });
      });
    },
  },
  watch: {
    applicationInfo: {
      handler(applicationInfo) {
        const { bankAccount, bankAccount: { uploadExtraProofs }, currentStep } = applicationInfo;
        console.log(bankAccount.currency, 'bankAccount.currency');

        const _data = { ...bankAccount, ...uploadExtraProofs, currency: bankAccount.currency.split() };
        const isDisabled = currentStep === 'status';
        if (isDisabled) {
          this.$refs.validationForm.setItemDisabled('', true, true);
        }
        if (_data.accountHolderName) {
          [
            'accountHolderName',
            'depositBank',
            'depositBranch',
            'currency',
            'accountNumber',
            'confirmAccountNumber',
            'uploadBankStatement',
            'bankAddress',
            'proofOfBankAccount',
          ].forEach(key => {
            this.$refs.validationForm.setItemValue(key, _data[key]);
          });
          const arr = [
            'extraDocument1',
            'extraDocument2',
            'extraDocument3',
            'extraDocument4',
            'extraDocument5',
            'uploadBankStatement',
            'proofOfBankAccount',
          ];
          arr.forEach(item => {
            this.form.uploadExtraProofs[item] = _data[item];
            _data[item] && this.form.uploadExtraProofs.fileList[item].push({
              url: _data[item],
              name: '',
            });
          });
          this.$nextTick(() => {
            this.$refs.validationForm.toFormValid(params => {
              const { accountHolderName, depositBank, currency, accountNumber, confirmAccountNumber } = params;
              // currency 如果是数组，转化为字符串
              const _currency = Array.isArray(currency) ? currency.join(',') : currency;
              const { uploadBankStatement, extraDocument1, extraDocument2, extraDocument3, extraDocument4, extraDocument5, proofOfBankAccount } = this.form.uploadExtraProofs;
              const bankAccount = {
                accountHolderName,
                depositBank,
                currency: _currency,
                accountNumber,
                confirmAccountNumber,
                uploadBankStatement,
                proofOfBankAccount,
                uploadExtraProofs: {
                  extraDocument1,
                  extraDocument2,
                  extraDocument3,
                  extraDocument4,
                  extraDocument5,
                },
              };
              this.$emit('onlyUpdateForm', { bankAccount, currentStep: 'bankAccount' });
            });
          });
        }
      },
      deep: true,
    },
    '$attrs.formData.businessType.businessLocation': {
      handler(value) {
        console.log(value, 'value');
      },
    },
  },
};
</script>

<style scoped lang="scss">
.button-box {
  width: 100%;

  .el-button {
    width: 100% !important;
  }
}
</style>
